import { BaseFirestoreService } from "../FirestoreService";
import { Help, HELP_COLLECTION, WithID } from "../../db";
import { FirestoreDocumentSnapshot } from "../../db/common";

/**
 * Shared Help Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class HelpService extends BaseFirestoreService<Help> {
    protected getCollectionPath(): string {
        return HELP_COLLECTION;
    }

    //@overwrite no need to specify id
    create(data: Omit<Help, 'breadcrumbs'>): Promise<string> {
        let newData: Help;
        switch (data.type) {
            case 'topic':
                newData = {
                    breadcrumbs: [],
                    related_topics: [],
                    sub_topics: [],
                    sub_articles: [],
                    ...data,
                    type: data.type,
                }
                break;
            case 'article':
                newData = {
                    breadcrumbs: [],
                    related_articles: [],
                    feedback_ratio: 0,
                    description: data.description || '',
                    ...data,
                    type: data.type,
                }
                break;
        }

        return super.create(newData)
    }

    public documentToEntity<T extends Help>(doc: FirestoreDocumentSnapshot): WithID<T> | null {
        const result = BaseFirestoreService.documentToEntity<Help>(doc);
        if (!result) return null;
        if (result.type === 'topic' || result.type === 'article') {
            return { ...result as unknown as T, id: result.id } as WithID<T>;
        }
        return null;
    }
}

